import request from "@/utils/request";

// 投诉记录列表
export function getComplaintListApi(data) {
    return request({
        url: "/admin/complaint",
        method: "get",
        params: data
    });
}

// 投诉记录-添加
export function addComplaintApi(data) {
  return request({
      url: "/admin/complaint",
      method: "post",
      data
  });
}


// 投诉记录-修改(获取)
export function fixGetComplaintApi(data) {
  return request({
      url: "/admin/complaint/" + data.id,
      method: "get",
      params: data
  });
}

// 投诉记录-修改(提交)
export function fixPutComplaintApi(data) {
  return request({
      url: "/admin/complaint/" + data.id,
      method: "put",
      data
  });
}

// 投诉记录-删除
export function deleteComplaintApi(data) {
  return request({
      url: "/admin/complaint/" + data.id,
      method: "delete",
      data
  });
}

// 投诉记录-提交审批
export function auditComplaintApi(data) {
  return request({
      url: "/admin/audit_complaint/" + data.id,
      method: "post",
      data
  });
}

// 投诉记录-查看历史记录
export function historyComplaintApi(data) {
  return request({
      url: "/admin/show_complaint_list/" + data.id,
      method: "get",
      params: data
  });
}

// 投诉记录-获取下拉框
export function getSelectApi(data) {
  return request({
      url: "/admin/get_complaint_select" ,
      method: "get",
      params: data
  });
}

// 投诉记录-获取内外部权限
export function getPermissionApi() {
  return request({
      url: "/admin/get_inner_outer_permission" ,
      method: "get",
  });
}


// 获取钉钉通知人
export function getTalkPersonApi(data) {
  return request({
      url: "/admin/get_ding_talk_admin",
      method: "get",
      data
  });
}
// 导出word
export function getExportWord(data) {
  return request({
      url:`/admin/download_complaint_docx/${data.id}`,
       method: "get",
       responseType: 'blob',
  });
}

